import colors from '@constants/colors';
import { FONT_SIZE_LEGEND, LABEL_SIZE_LEGEND } from '@constants/KPI/kpi-common';

const tickOptions = {
	color: colors.indigo30,
	padding: 10,
};

const gridOptions = {
	tickColor: colors.indigo30,
	color: colors.indigo30,
	lineWidth: 0.5,
};

const pointOptions = {
	radius: 4,
	hoverRadius: 6,
};

const pluginOptions = {
	legend: {
		display: false,
		fullSize: true,
		labels: {
			color: colors.indigo70,
			boxHeight: LABEL_SIZE_LEGEND,
			boxWidth: LABEL_SIZE_LEGEND,
			font: {
				size: FONT_SIZE_LEGEND,
			},
		},
	},
	tooltip: {
		backgroundColor: colors.indigo70,
	},
	colors: {
		enabled: true,
	},

};

export const historyCheckChartOptions = {
	responsive: true,
	maintainAspectRatio: false,
	animation: {
		duration: 0,
	},
	elements: {
		point: pointOptions,
	},
	scales: {
		x: {
			ticks: tickOptions,
			grid: gridOptions,
		},
		y: {
			ticks: {
				...tickOptions,
				callback: (value: string | number) => value.toLocaleString().replaceAll(',', ' '),
			},
			grid: gridOptions,
		},
	},
	plugins: pluginOptions,
};

export const datasetOptions = {
	fill: false,
	borderColor: colors.indigo70,
	tension: 0.1,
	pointBackgroundColor: colors.indigo30,
	pointBorderColor: colors.indigo70,
	backgroundColor: colors.indigo70,
};
